<script lang="ts">
	export let slug = '';
	export let title;
</script>

{#if slug}
	<h3 class="m-0 mb-2">
		<p class="text-xl text-bloomBlueNormal font-bold">
			{title}
		</p>
	</h3>
	<!-- {topicColor} -->
{:else}
	<h2 class="m-0">
		<p class="text-bloomBlueNormal text-xl">
			{title}
		</p>
	</h2>
	<!-- {topicColor} -->
{/if}
